import * as React from "react"
import PrimaryButton from "../PrimaryButton"
import { useSelector } from "react-redux"
import * as AppTypes from "AppTypes"

interface IFirstUploadProps {
    onClick: () => void
}
const FirstUpload: React.FC<IFirstUploadProps> = props => {
    const { onClick } = props
    const { langPack } = useSelector((store: AppTypes.ReducerState) => ({
        langPack: store.config.langPack
    }))
    return (
        <div className="upload">
            <div className="upload__header">
                <div className="upload__icon"></div>
            </div>
            <div className="upload__content">
                <h3>{langPack["uploadDescription"]}</h3>
                <p>{langPack["entireArtwork"]}</p>
            </div>
            <div className="upload__action">
                <PrimaryButton
                    className="button--blue"
                    text={langPack["buttonOk"]}
                    onClick={onClick}
                />
            </div>
        </div>
    )
}

export default FirstUpload